import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function AdminSettings() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setS(r.data || {})); }, []);

  const upd = (k, v) => setS({...s, [k]: v});

  const save = async () => {
    try {
      await api.put("/admin/settings", {
        ...s,
        free_shipping_threshold: s.free_shipping_threshold !== undefined ? Number(s.free_shipping_threshold) : undefined,
        pix_discount: s.pix_discount !== undefined ? Number(s.pix_discount) : undefined,
        max_installments: s.max_installments !== undefined ? Number(s.max_installments) : undefined,
      });
      toast.success("Configurações salvas");
    } catch { toast.error("Erro"); }
  };

  return (
    <div className="space-y-5" data-testid="admin-settings">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl text-[#4A3B40]">Configurações da loja</h1>
        <button onClick={save} className="btn-lara" data-testid="settings-save"><Save className="w-4 h-4" /> Salvar</button>
      </div>

      <div className="bg-white rounded-2xl border border-[#F9E1E8] p-5 grid md:grid-cols-2 gap-3">
        <div><label className="text-xs text-[#8C7A80]">Nome da loja</label><input className="st" value={s.store_name||""} onChange={(e)=>upd("store_name",e.target.value)} /></div>
        <div><label className="text-xs text-[#8C7A80]">E-mail</label><input className="st" value={s.email||""} onChange={(e)=>upd("email",e.target.value)} /></div>
        <div><label className="text-xs text-[#8C7A80]">WhatsApp</label><input className="st" value={s.whatsapp||""} onChange={(e)=>upd("whatsapp",e.target.value)} /></div>
        <div><label className="text-xs text-[#8C7A80]">Instagram</label><input className="st" value={s.instagram||""} onChange={(e)=>upd("instagram",e.target.value)} /></div>
        <div><label className="text-xs text-[#8C7A80]">CNPJ</label><input className="st" value={s.cnpj||""} onChange={(e)=>upd("cnpj",e.target.value)} /></div>
        <div><label className="text-xs text-[#8C7A80]">Endereço</label><input className="st" value={s.address||""} onChange={(e)=>upd("address",e.target.value)} /></div>
      </div>

      <div className="bg-white rounded-2xl border border-[#F9E1E8] p-5">
        <h3 className="font-serif text-lg text-[#4A3B40] mb-3">Frete e pagamento</h3>
        <div className="grid md:grid-cols-3 gap-3">
          <div><label className="text-xs text-[#8C7A80]">Frete grátis acima de (R$)</label><input className="st" type="number" step="0.01" value={s.free_shipping_threshold||""} onChange={(e)=>upd("free_shipping_threshold",e.target.value)} data-testid="settings-free-shipping" /></div>
          <div><label className="text-xs text-[#8C7A80]">Desconto PIX (%)</label><input className="st" type="number" value={s.pix_discount||""} onChange={(e)=>upd("pix_discount",e.target.value)} /></div>
          <div><label className="text-xs text-[#8C7A80]">Parcelamento máximo</label><input className="st" type="number" value={s.max_installments||""} onChange={(e)=>upd("max_installments",e.target.value)} /></div>
        </div>
      </div>

      <style>{`.st{width:100%;margin-top:4px;border:1px solid #F9E1E8;background:#FFF9FA;border-radius:12px;padding:10px 14px;outline:none;font-size:14px;color:#4A3B40}.st:focus{border-color:#C9708B}`}</style>
    </div>
  );
}
